/**
 * The payroll run status vocabulary, in a module that imports nothing.
 *
 * Same bundle decision as `offer-vocabulary.ts`: `router.tsx` imports every
 * route's `validateSearch` schema EAGERLY, so what a search module reaches for
 * lands in the initial chunk. `payroll-runs.route.search.ts` filters on this
 * tuple, and taking it from `schemas/payroll-run.schema.ts` pulled every run,
 * preview, failure-report and create-input schema in with it.
 *
 * The tuple is the single source of truth: `payroll-run.schema.ts` validates
 * the wire `status` field against it, so the URL parser and the wire parser
 * cannot drift.
 */

/// The run status machine of design 2.2, mirrored from the shore's
/// `engine/payroll-run-state.ts`. The wizard derives every step from it.
export const RUN_STATUSES = [
  "draft",
  "processing",
  "slips_created",
  "submitted",
  "paid",
  "failed",
  "cancelled",
] as const;
export type RunStatus = (typeof RUN_STATUSES)[number];
